import type { ThemeConfig } from '../types'
import { expeditionConfig as generated } from '../../generated/theme-presets'

// Expedition: RETRO STAMP COLLECTOR. This UI got stamped, not designed. Square badges
// like passport stamps. Uppercase headings with w i d e tracking like a national park
// sign carved in wood. Dotted borders like perforated tear-off edges. Heavy hard-offset
// shadows like a block print. Topographic contour lines ripple across the background.
// Narrow content column — like a field notebook page. Every card feels punched from cardstock.
export const expeditionConfig: ThemeConfig = generated
